import React, { useRef, useState, useLayoutEffect } from "react";
import { gsap } from "gsap";
import styled from "@emotion/styled";
import CardCourses from "./CardCourses/CardCourses";

const ContainerDiv = styled.div`
  width: 100%;

  .viewport {
    width: 100%;
    padding: 6rem 0;
  }

  .track {
    position: relative;
    height: 45rem;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
  }

  .card {
    position: absolute;
    top: 0;
    width: 28rem;
    background: linear-gradient(180deg, #1a1a1a, #0e0e0e);
    border-radius: 1.5rem;
    box-shadow: 0 0 40px rgba(255, 180, 80, 0.15);
    cursor: pointer;
    will-change: transform, opacity;
  }

  .course-image {
    width: 100%;
    height: 28rem;
    background-position: top;
    background-repeat: no-repeat;
    background-size: cover;
    border-top-left-radius: 1.5rem;
    border-top-right-radius: 1.5rem;
  }

  .course-info {
    i {
      color: var(--brand-1);
      font-size: 3.5rem;
    }

    .course-name {
      color: var(--brand-1);
      font-weight: 700;
    }

    .qty {
      font-size: 1.4rem;
      color: #f5e7d3;
      font-weight: 700;
    }
  }

  .course-d {
    color: #b8b8b8;
    padding: 3rem 2rem 0rem 2rem;
    line-height: 1.625;
    height: 16rem;
  }

  .course-btn {
    background: #000;
    width: 100%;
    background: -webkit-linear-gradient(to right, #414345, #000);
    background: linear-gradient(to right, #414345, #000);
    border-bottom-right-radius: 1.5rem;
    border-bottom-left-radius: 1.5rem;
    padding: 1.2rem 0;
    color: var(--brand-1);
    font-weight: 700;
    font-size: 1.4rem;
    box-shadow: 0px -16px 20px -4px var(--main-btn-shadow),
      0 2px 20px -4px rgb(0 0 0 / 22%), 0 0 10px -4px #fff;
  }

  @media only screen and (min-width: 764px) {
    .card {
      width: 35rem;
    }
  }
`;

const array_courses = [
  {
    _id: "1",
    content: {
      course_img:
        "https://res.cloudinary.com/djiqf3usa/image/upload/v1769811102/Clients/LTMastery/Frontpage/Images/Imagenes%20con%20SEO/sensual-bachata-dance-challenges-training_jnionq.webp",
    },
    course_info: {
      course_instructor: "Luis and Tay",
      course_name: "Challenges",
      course_level: "All Levels",
      course_qty: "37",
      course_description:
        "Challenge your limits with guided drills and creative tasks that sharpen control, timing, and confidence fast daily focus",
    },
  },
  {
    _id: "2",
    content: {
      course_img:
        "https://res.cloudinary.com/djiqf3usa/image/upload/v1769811110/Clients/LTMastery/Frontpage/Images/Imagenes%20con%20SEO/sensual-bachata-foundations-technique-training_kq1osg.webp",
    },
    course_info: {
      course_instructor: "Luis and Tay",
      course_name: "Foundations",
      course_level: "All Levels",
      course_qty: "16",
      course_description:
        "Build strong fundamentals with clear technique, body mechanics, and musical understanding designed for long-term growth.",
    },
  },
  {
    _id: "3",
    content: {
      course_img:
        "https://res.cloudinary.com/djiqf3usa/image/upload/v1769811112/Clients/LTMastery/Frontpage/Images/Imagenes%20con%20SEO/sensual-bachata-beginner-course-start-from-zero_tyfpt9.webp",
    },
    course_info: {
      course_instructor: "Luis and Tay",
      course_name: "Beginner",
      course_level: "All Levels",
      course_qty: "50",
      course_description:
        "Start from zero with simple, structured lessons that build confidence, coordination, and connection step by step safely",
    },
  },
  {
    _id: "4",
    content: {
      course_img:
        "https://res.cloudinary.com/djiqf3usa/image/upload/v1769811107/Clients/LTMastery/Frontpage/Images/Imagenes%20con%20SEO/sensual-bachata-intermediate-technique-and-flow_snxpct.webp",
    },
    course_info: {
      course_instructor: "Luis and Tay",
      course_name: "Intermediate",
      course_level: "All Levels",
      course_qty: "70",
      course_description:
        "Expand your movement range with technique, transitions, and flow that improve clarity and social dance control now fast",
    },
  },
  {
    _id: "5",
    content: {
      course_img:
        "https://res.cloudinary.com/djiqf3usa/image/upload/v1769811105/Clients/LTMastery/Frontpage/Images/Imagenes%20con%20SEO/advanced-sensual-bachata-musicality-and-connection_nariuc.webp",
    },
    course_info: {
      course_instructor: "Luis and Tay",
      course_name: "Advanced",
      course_level: "All Levels",
      course_qty: "60",
      course_description:
        "Refine precision, musicality, and expression through advanced concepts that elevate presence and partner awareness deep",
    },
  },
  {
    _id: "6",
    content: {
      course_img:
        "https://res.cloudinary.com/djiqf3usa/image/upload/v1769811546/Clients/LTMastery/Frontpage/Images/Imagenes%20con%20SEO/sensual-bachata-styling-body-movement-training_p1xswb.webp",
    },
    course_info: {
      course_instructor: "Luis and Tay",
      course_name: "Stylings",
      course_level: "All Levels",
      course_qty: "40",
      course_description:
        "Develop clean styling and body awareness to add texture, elegance, and personality to every movement free now",
    },
  },
  {
    _id: "7",
    content: {
      course_img:
        "https://res.cloudinary.com/djiqf3usa/image/upload/v1769811108/Clients/LTMastery/Frontpage/Images/Imagenes%20con%20SEO/sensual-bachata-performance-choreography-training_iprzxi.webp",
    },
    course_info: {
      course_instructor: "Luis and Tay",
      course_name: "Performances",
      course_level: "All Levels",
      course_qty: "40",
      course_description:
        "Train choreography and performance skills to project confidence, musical timing, and stage-ready presence steadily now!!",
    },
  },
];

const CARD_WIDTH = 210;
const GAP = 25;

// 🔧 CALIBRACIÓN MÁS NATURAL
const SWIPE_THRESHOLD = 15;

const ContainerCourses = () => {
  const cardsRef = useRef([]);
  const centerIndex = Math.floor(array_courses.length / 2);
  const [active, setActive] = useState(centerIndex);

  const startX = useRef(0);
  const isDragging = useRef(false);
  const wheelLock = useRef(false);

  useLayoutEffect(() => {
    animate();
    // eslint-disable-next-line
  }, [active]);

  const animate = () => {
    gsap.killTweensOf(cardsRef.current);

    cardsRef.current.forEach((card, i) => {
      if (!card) return;

      const offset = i - active;

      gsap.to(card, {
        x: offset * (CARD_WIDTH + GAP),
        scale: offset === 0 ? 1 : 0.85,
        rotateY: offset === 0 ? 0 : offset * -15,
        opacity: Math.abs(offset) > 2 ? 0 : 1,
        zIndex: 10 - Math.abs(offset),
        duration: 0.6,
        ease: "power3.out",
      });
    });
  };

  const handleSwipe = (distance) => {
    if (Math.abs(distance) < SWIPE_THRESHOLD) return;

    if (distance > 0 && active < array_courses.length - 1) {
      setActive((prev) => prev + 1);
    }

    if (distance < 0 && active > 0) {
      setActive((prev) => prev - 1);
    }
  };

  const onTouchStart = (e) => {
    startX.current = e.touches[0].clientX;
  };

  const onTouchEnd = (e) => {
    handleSwipe(startX.current - e.changedTouches[0].clientX);
  };

  const onMouseDown = (e) => {
    isDragging.current = true;
    startX.current = e.clientX;
  };

  const onMouseUp = (e) => {
    if (!isDragging.current) return;
    isDragging.current = false;
    handleSwipe(startX.current - e.clientX);
  };

  const onMouseLeave = () => {
    isDragging.current = false;
  };

  const onWheel = (e) => {
    if (wheelLock.current) return;
    if (Math.abs(e.deltaX) < Math.abs(e.deltaY)) return;

    wheelLock.current = true;
    handleSwipe(e.deltaX);

    setTimeout(() => {
      wheelLock.current = false;
    }, 250);
  };

  return (
    <ContainerDiv>
      <div className="viewport">
        <div
          className="track"
          onTouchStart={onTouchStart}
          onTouchEnd={onTouchEnd}
          onMouseDown={onMouseDown}
          onMouseUp={onMouseUp}
          onMouseLeave={onMouseLeave}
          onWheel={onWheel}
        >
          {Array.isArray(array_courses) &&
            array_courses.map((info, index) => (
              <CardCourses
                key={info._id}
                options={{ objinfo: info, cardsRef, index, active, setActive }}
              />
            ))}
        </div>
      </div>
    </ContainerDiv>
  );
};

export default ContainerCourses;
